import { routesAndPagesMap } from "Common/routingUtils";
import isFunction from "lodash/isFunction";
export function getLinkHref(href, routingKey) {
    const result = href || (routingKey && routesAndPagesMap.getPath(routingKey));
    return result && result !== window.location.hash ? result : "";
}
export function needMessageLink(messageLink) {
    return (messageLink === null || messageLink === void 0 ? void 0 : messageLink.href) || (isFunction(messageLink === null || messageLink === void 0 ? void 0 : messageLink.onClick) && (messageLink === null || messageLink === void 0 ? void 0 : messageLink.title));
}
